import { lazy } from "react";

export const DailyExercisesTableAsync = lazy(
  () => import("./DailyExercisesTable")
);
